import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '../services/AuthService';

// Route guard: unauthenticated users are sent to /login and returned
// to their original destination after signing in.
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
